import { KnownProjectDtoProjectType, KnownUserDtoUserType } from '@groundfloor-platform/mgmt-service-g-sdk';

export function mapProjectTypeToUserType(projectType?: string) {
  switch (projectType) {
    case KnownProjectDtoProjectType.CommercialBuilding:
    case KnownProjectDtoProjectType.ResidentialBuilding:
    case KnownProjectDtoProjectType.Business:
      return KnownUserDtoUserType.Occupant;
    case KnownProjectDtoProjectType.Retailer:
    case KnownProjectDtoProjectType.Store:
      return KnownUserDtoUserType.Customer;
    default:
      return KnownUserDtoUserType.User;
  }
}
